module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-login-reg-source-tip",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a8cb798", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a8cb798!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/RegSourceTip.vue
// module id = 862
// module chunks = 0